import React from 'react';
import {Card, Loader, Table} from 'semantic-ui-react';
import {ordersTypes} from '../../../common/dictionaries/accessories';

const DetailList = ({orders}) => {
  if (!orders.length) {
    return (
      <Table.Row textAlign='center'>
        <Table.Cell colSpan={6}>No hay órdenes</Table.Cell>
      </Table.Row>
    );
  }

  return orders.map((item, index) => {
    return (
      <Table.Row key={index} textAlign='center'>
        <Table.Cell>{ordersTypes[item.orderType]}</Table.Cell>
        <Table.Cell>{item.order}</Table.Cell>
        <Table.Cell>{item.statusName}</Table.Cell>
        <Table.Cell>{item.dealer}</Table.Cell>
        <Table.Cell>{item.chassis}</Table.Cell>
        <Table.Cell>{item.description}</Table.Cell>
      </Table.Row>
    );
  });
};

const LoaderDetailList = () => {
  return (
    <Table.Row textAlign='center'>
      <Table.Cell colSpan={6}>
        <Loader active inline='centered'>
          Consultando...
        </Loader>
      </Table.Cell>
    </Table.Row>
  );
};

const Detail = ({loading, orders}) => {
  return (
    <Card raised fluid>
      <Table striped>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell>Tipo</Table.HeaderCell>
            <Table.HeaderCell>Orden</Table.HeaderCell>
            <Table.HeaderCell>Estado</Table.HeaderCell>
            <Table.HeaderCell>Cliente</Table.HeaderCell>
            <Table.HeaderCell>Chasis</Table.HeaderCell>
            <Table.HeaderCell>Modelo</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {loading ? <LoaderDetailList /> : <DetailList orders={orders} />}
        </Table.Body>
      </Table>
    </Card>
  );
};

export default Detail;
